import AXIOS from '@/axios-instance';

export default {

  saveLink(uuid, elementId, text) {
    return AXIOS.post("/mngmtLink", {
      text: text,
      uuidModel: uuid,
      elementId: elementId,
    });
  },
  getMngmtLink(uuidModel, elementId) {
    return AXIOS.get("/mngmtLink/bpmn/" + uuidModel + "/element/" + elementId);
  },
  retrieveElementsWithLinks(uuid){
    return AXIOS.get("/mngmtLink/bpmn/" + uuid);
    }
}